<template>
  <div class="py-3">
    <page-title title="Templates" />
    <hr />
    <filtered-table :settings="tableSettings" @rowClicked="onRowClicked">
    </filtered-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TemplateList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        endpoint: '/api/template',
        columns: [
          {
            key: 'id',
            name: 'ID',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'key',
            name: 'Key',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'title',
            name: 'Title',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'description',
            name: 'Description',
            visible: false,
            sortable: true,
            filter: 'text'
          }
        ],
        getDefaultFilter: function () {
          return '';
        }
      }
    }
  },
  methods: {
    onRowClicked: function (item, context) {
      this.$router.push('/template/' + item.id);
    }
  },
  mounted () {
  }
};
</script>